import { Injectable, Injector } from '@angular/core';
import { take } from 'rxjs';
import { filterNull } from 'src/util/rxjs/operators';
import { FlightLogApiHttpClient } from '../shared/flight-log-api/flight-log-api.service';
import { CurrentUserService } from './current-user.service';

@Injectable({ providedIn: 'root' })
export class AppInitService {
  constructor(private _currentUser: CurrentUserService, private _api: FlightLogApiHttpClient) {}
  public async init() {
    this._currentUser.valueChanges.pipe(filterNull(), take(1)).subscribe(async () => {
      await Promise.all([
        this._api.getApproachTypes().toPromise(),
        this._api.getDepartureTypes().toPromise(),
      ]);
    });
  }
}

export function initApp(appInit: AppInitService, injector: Injector) {
  return async () => {
    if (appInit == null) {
      // Sometimes app init is injected as undefined, so use the injector. 😢
      // This is not ideal, if we can figure out what is causing the issue that would be better
      appInit = injector.get(AppInitService);
    }
    await appInit.init();
  };
}
